import React from 'react';

export function SortableTh({
  label, sortKey, activeKey, dir, onSort, className = '',
}) {
  const active = activeKey === sortKey;
  return (
    <th className={className}>
      <button
        type="button"
        className={`users-sort-th${active ? ' is-active' : ''}`}
        onClick={() => onSort(sortKey)}
      >
        {label}
        {active && <span className="users-sort-arrow" aria-hidden>{dir === 'asc' ? ' ▲' : ' ▼'}</span>}
      </button>
    </th>
  );
}

export default SortableTh;
